import { EventType } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const eventTypeTag = "EventType";

export const eventTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEventTypes: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/event-types${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [eventTypeTag],
    }),
    createEventType: builder.mutation({
      query: (payload: EventType) => ({
        url: "/gw/event-types",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [eventTypeTag],
    }),
    updateEventType: builder.mutation({
      query: ({ id, ...payload }: EventType) => ({
        url: `/gw/event-types/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [eventTypeTag],
    }),
    deleteEventType: builder.mutation({
      query: (id: number) => ({
        url: `/gw/event-types/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [eventTypeTag],
    }),
  }),
});

export const {
  useGetEventTypesQuery,
  useCreateEventTypeMutation,
  useUpdateEventTypeMutation,
  useDeleteEventTypeMutation,
} = eventTypeApi;
